import { useState } from 'react';

export default function useMuiMenu() {
    const [ anchorEl, setAnchorEl ] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return {
        openMenuButtonAnchor: anchorEl,
        open,
        handleMenuOpenClick: handleClick,
        closeMenu: handleClose
    };
}
